export default __webpack_public_path__ + "static/media/helpcenter.56d08a56.png";